import { useEffect } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";

import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import SciencePage from "./pages/SciencePage";
import SolutionsPage from "./pages/SolutionsPage";
import VerticalsPage from "./pages/VerticalsPage";
import PrivacyPage from "./pages/PrivacyPage";
import TermsPage from "./pages/TermsPage";

const TITLES: Record<string, string> = {
  "/": "Upside Digital. Performance marketing, built end to end.",
  "/about-us": "About — Upside Digital",
  "/science": "Science — Upside Digital",
  "/solutions": "Solutions — Upside Digital",
  "/verticals": "Verticals — Upside Digital",
  "/privacy-policy-and-disclaimer": "Privacy — Upside Digital",
  "/terms-conditions": "Terms — Upside Digital",
};

// Reset scroll position and document title on every route change, mimicking the
// full-page navigation behaviour of the original multi-page site.
function RouteEffects() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = TITLES[pathname] ?? "Upside Digital";
  }, [pathname]);
  return null;
}

export default function App() {
  return (
    <BrowserRouter>
      <RouteEffects />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about-us" element={<AboutPage />} />
        <Route path="/science" element={<SciencePage />} />
        <Route path="/solutions" element={<SolutionsPage />} />
        <Route path="/verticals" element={<VerticalsPage />} />
        <Route path="/privacy-policy-and-disclaimer" element={<PrivacyPage />} />
        <Route path="/terms-conditions" element={<TermsPage />} />
        <Route path="*" element={<HomePage />} />
      </Routes>
    </BrowserRouter>
  );
}
